import PropTypes from 'prop-types';
import React from 'react';
import numeral from 'numeral';

const SHORT_BYTE_FORMAT = '0 b';
const MEDIUM_BYTE_FORMAT = '0.0 b';
const LONG_BYTE_FORMAT = '0.00 b';

const SHORT_LIMIT = Math.pow(1024, 3);
const MEDIUM_LIMIT = Math.pow(1024, 4);

function pickFormat(size) {
  if (size < SHORT_LIMIT) {
    return SHORT_BYTE_FORMAT;
  } else if (size < MEDIUM_LIMIT) {
    return MEDIUM_BYTE_FORMAT;
  } else {
    return LONG_BYTE_FORMAT;
  }
}

function ByteSize(props) {
  const value =
    props.raw === 0 ? '0 KB' : numeral(props.raw).format(pickFormat(props.raw));

  return (
    <span
      className="inline-block"
      title={`${numeral(props.raw).format()} bytes`}
    >
      {value}
    </span>
  );
}

ByteSize.propTypes = {
  raw: PropTypes.number.isRequired
};

ByteSize.defaultProps = {
  raw: 0
};

export { ByteSize };
